import { Modals } from '../../types';
import { LoadingModal } from '../LoadingModal/LoadingModal';
import { UserConsent } from '../UserConsent/UserConsent';
import { UpgradeToPremium } from '../UpgradeToPremium/UpgradeToPremium';
import { ConnectDomain } from '../ConnectDomain/ConnectDomain';
import { BusinessFirstModal } from '../BusinessFirstModal/BusinessFirstModal';
import { ErrorModal } from '../ErrorModal/ErrorModal';
import React, { lazy, Suspense } from 'react';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
import { GoToOtherTabModal } from '../GoToOtherTabModal/GoToOtherTabModal';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
import { InstallingLoader } from '../InstallLoader/InstallingLoader';
import { ModalWrapper } from './ModalWrapper';
const LazySiteSelectorModal = /*#__PURE__*/lazy(() => import('../SiteSelectorModal/SiteSelectorModal'));
const LazyDevSiteSelectorModal = /*#__PURE__*/lazy(() => import('../DevModeSiteSelector/DevModeSiteSelectorModal'));
const ACTIVE_MODAL_MAPPING = {
  [Modals.none]: () => /*#__PURE__*/React.createElement(React.Fragment, null),
  [Modals.error]: ErrorModal,
  [Modals.loading]: LoadingModal,
  [Modals.userConsent]: UserConsent,
  [Modals.connectDomain]: ConnectDomain,
  [Modals.siteSelector]: LazySiteSelectorModal,
  [Modals.businessFirst]: BusinessFirstModal,
  [Modals.upgradeToPremium]: UpgradeToPremium,
  [Modals.devModeSiteSelector]: LazyDevSiteSelectorModal,
  [Modals.goToOtherTab]: GoToOtherTabModal,
  [Modals.installingLoader]: InstallingLoader
};
const getIsLazyModal = activeModal => activeModal === Modals.siteSelector || activeModal === Modals.devModeSiteSelector;
export const ModalRenderer = () => {
  const {
    isLoadingInstaller
  } = useRenderControl();
  const {
    activeModal
  } = useModalsAndWindow();
  const isLazyModal = getIsLazyModal(activeModal);
  const WrapperComponent = isLazyModal ? Suspense : ModalWrapper;
  const ActiveModal = ACTIVE_MODAL_MAPPING[activeModal];
  return /*#__PURE__*/React.createElement(WrapperComponent, {
    isOpen: activeModal !== Modals.none || isLoadingInstaller,
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, isLoadingInstaller && /*#__PURE__*/React.createElement(LoadingModal, null), /*#__PURE__*/React.createElement("div", {
    style: {
      display: isLoadingInstaller ? 'none' : 'unset'
    }
  }, /*#__PURE__*/React.createElement(ActiveModal, null)));
};
//# sourceMappingURL=ModalRenderer.js.map